import "./styles.scss";
import React, { useState, useEffect } from "react";
import {
	Col,
	Container,
	Row,
	Card,
	CardBody,
	CardText,
	Badge,
	Nav,
	NavItem,
	NavLink,
	BreadcrumbItem,
	Media,
	Spinner,
} from "reactstrap";
import "assets/scss/website/app.scss";
import { MetaTags } from "react-meta-tags";
import "react-rangeslider/lib/index.css";
import "react-multi-carousel/lib/styles.css";
import PropertyService from "services/Website/PropertyService";
import { SuccessOk } from "configs/statusCode";
import { useSelector, useDispatch } from "react-redux";
import InterestServices from "services/Website/InterestServices";
import { useTranslation } from "react-i18next";
import CallModal from "components/Website/Cards/CallModal";
import Skeleton from "components/Website/Skeleton";
import http from "services/HttpService";
import MessageModal from "components/Website/Cards/MessageModal";
import CheckAvailabilityModal from "components/Website/Cards/CheckAvailabilityModal";
import BuyUnitModal from "components/Website/Cards/BuyUnit";
import { Link } from "react-router-dom";

const PropertyBuyDetails = (props) => {
	const [callModal, setCallModal] = useState(false);
	const [messageModal, setMessageModal] = useState(false);
	const [checkAvailabilityModal, setCheckAvailabilityModal] = useState(false);
	const [buyModal, setBuyModal] = useState(false);
	const { id } = props.match.params;
	const { t } = useTranslation();
	const propertyService = new PropertyService();
	const [propertyDetails, setPropertyDetails] = useState({});
	const [exchangeRate, setExchangeRate] = useState({});
	const [buyLoading, setBuyLoading] = useState(0);
	const [checkAvailability, setCheckAvailability] = useState(null);
	const [DetailsLoading, setDetailsLoading] = useState(true);
	const AuthData = useSelector((state) => state.Auth);
	const currency = useSelector((state) => state.Auth?.currency);

	useEffect(() => {
		http.setLang();
		propertyService.find(id).then((response) => {
			if (response && response.status === SuccessOk) {
				setPropertyDetails(response.data);
				setCheckAvailability(response.data.check_availability);
				setExchangeRate(response.data.exchangeRate);
				response.data.payment_plans.sort(
					(a, b) => a.years.length - b.years.length
				);
				const updatedPlans = response.data.payment_plans.map((plan) => {
					return {
						...plan,
						years: plan.years.map((year) => {
							let payableYear = year.total;
							for (const key in year.years) {
								const month = year.years[key];
								if (month?.off_payment) {
									month?.off_payment.forEach((item) => {
										payableYear = payableYear + item.payment_fees;
									});
								}
							}
							return {
								...year,
								total: payableYear,
							};
						}),
					};
				});
				setDetailsLoading(false);
			}
		});
	}, []);

	const handleCheckAvailability = () => {
		let data = {
			unit_id: propertyDetails.id,
		};

		setBuyLoading(true);
		propertyService.checkProperty(data).then((res) => {
			if (res && res.status === SuccessOk) {
				setCheckAvailabilityModal(true);
				setCheckAvailability(1);
			}
			setBuyLoading(false);
		});
	};

	const BuyUnitHandler = () => {
		setBuyModal((c) => !c);
		// let data = {
		//   "unit_id": propertyDetails.id
		// }
		// setBuyLoading(true)
		// propertyService.buyUnit(data).then(res => {
		//   if (res && res.status === SuccessOk) {
		//     toast.success(t("Deal Created successfully"))
		//     setBuyLoading(false)
		//   } else {
		//     setBuyLoading(false)
		//   }
		// })
	};

	if (DetailsLoading) {
		return <Skeleton.ProprtyBuyDetails history={props.history} />;
	}
	return (
		<div className="websitPages pt-10rem">
			<MetaTags>
				<title>{t("Property Details")}</title>
			</MetaTags>
			<div>
				<Container fluid className="px-lg-5 px-3 pb-5">
					<p
						className="font-size-32 text-primary"
						dangerouslySetInnerHTML={{
							__html: t("Property Process"),
						}}></p>
					<Row className="mt-3 p-2">
						<Col md={3} className="my-2 ">
							<div className="details-box">
								<p className="font-size-12 mb-0 text-color">Unit Code</p>
								<h5 className="fw-bold text-primary mb-0 font-size-18 mt-1">
									{propertyDetails?.name[`${AuthData.lang}`]
										? propertyDetails.name[`${AuthData.lang}`]
										: propertyDetails.name?.en}
								</h5>
							</div>
						</Col>
						<Col md={3} className="my-2 ">
							<div className="details-box">
								<p className="font-size-12 mb-0 text-color">Location</p>
								<h5 className="fw-bold text-primary mb-0 font-size-18 mt-1">
									{propertyDetails.area?.name[`${AuthData.lang}`]
										? propertyDetails.area?.name[`${AuthData.lang}`]
										: propertyDetails.area?.name?.en}
								</h5>
							</div>
						</Col>
						<Col md={3} className="my-2 ">
							<div className="details-box">
								<p className="font-size-12 mb-0 text-color">Compound Name</p>
								<h5 className="fw-bold text-primary mb-0 font-size-18 mt-1">
									{propertyDetails.coumound?.name[`${AuthData.lang}`]
										? propertyDetails.coumound?.name[`${AuthData.lang}`]
										: propertyDetails.coumound?.name?.en}
								</h5>
							</div>
						</Col>
						<Col md={3} className="my-2 ">
							<div className="details-box">
								<p className="font-size-12 mb-0 text-color">Built Up Area</p>
								<h5 className="fw-bold text-primary mb-0 font-size-18 mt-1">
									{parseInt(propertyDetails?.size)} sqm
								</h5>{" "}
							</div>
						</Col>
						<Col md={3} className="my-2 ">
							<div className="details-box">
								<p className="font-size-12 mb-0 text-color">Price</p>
								<h5 className="fw-bold text-primary mb-0 font-size-18 mt-1">
									{exchangeRate?.symbol === "*"
										? toCurrency(
												propertyDetails?.price * exchangeRate?.exchange_rate
										  )
										: toCurrency(
												propertyDetails?.price / exchangeRate?.exchange_rate
										  )}{" "}
									{currency?.currency_code}
								</h5>
							</div>
						</Col>
						<Col md={3} className="my-2 ">
							<div className="details-box">
								<p className="font-size-12 mb-0 text-color">Payment Method</p>
								<h5 className="fw-bold text-primary mb-0 font-size-18 mt-1">
									{propertyDetails?.payment_method &&
									propertyDetails.payment_method !== "Cash"
										? `Up to ${propertyDetails?.payment_method}`
										: " Cash only"}
								</h5>
							</div>
						</Col>
						<Col md={3} className="my-2 ">
							<div className="details-box">
								<p className="font-size-12 mb-0 text-color">Unit Type</p>
								<h5 className="fw-bold text-primary mb-0 font-size-18 mt-1">
									{propertyDetails.unit_type?.name[`${AuthData.lang}`]}
								</h5>
							</div>
						</Col>
					</Row>
					<Row className="mt-5 justify-content-center">
						{checkAvailability !== 2 && (
							<Col md={6}>
								<div className="text-center">
									<p className="bask-font fs-1 text-primary fw-medium">{t("Check Availability")}</p>
									<p className="mb-0 fw-light pb-4 font-size-18 text-primary text-uppercase">
										Kindly Click on the Check Availability button to make sure
										that the unit is available,
									</p>
									{/* <p>Once it's make sure available, click on Buy Now.</p> */}
									<button
										className={`btn px-5 rounded-pill mb-2 py-3 text-center ${
											checkAvailability == 1 ? "btn-secondary" : "btn-primary"
										}`}
										disabled={
											checkAvailability === 1 || buyLoading ? true : false
										}
										onClick={() => handleCheckAvailability()}
										style={{
											background:
												checkAvailability === 1
													? "var(--bs-btn-disabled-bg)"
													: "var(--primary-color)",
											borderColor:
												checkAvailability === 1
													? "var(--bs-btn-disabled-bg)"
													: "var(--primary-color)",
										}}>
										{t("Check Availability")}
									</button>
								</div>
							</Col>
						)}
					</Row>
					<Row className="justify-content-center">
						{checkAvailability === 2 && (

							<Col md={6} className="text-center">
								<p className="bask-font fs-1 text-primary fw-medium">{t("The Unit Is Available")}</p>
								<p className="mb-0 fw-light pb-4 font-size-18 text-primary text-uppercase">
									{t("THIS UNIT IS AVAILABLE YOU CAN BUY IT NOW")}
								</p>
								<div className="d-flex justify-content-center">
									<button
										className={`btn px-5 rounded-pill mb-2 py-3 text-center ${
											checkAvailability === 2 ? "btn-primary" : "btn-secondary"
										}`}
										disabled={checkAvailability !== 2 ? true : false}
										style={{
											display : checkAvailability !== 2 ? "none" : "block",
											float: checkAvailability !== 2 ? "right" : "left",
											background:
												checkAvailability !== 2
													? "var(--bs-btn-disabled-bg)"
													: "var(--primary-color)",
											borderColor:
												checkAvailability !== 2
													? "var(--bs-btn-disabled-bg)"
													: "var(--primary-color)",
										}}
										onClick={() => BuyUnitHandler()}>
										{t("Buy Now")}
									</button>
								</div>
							</Col>
						)
					}
					</Row>
				</Container>

				{buyModal && (
					<BuyUnitModal
						modal={buyModal}
						setModal={setBuyModal}
						propsList={props}
						details={propertyDetails}
						unitType="property"
					/>
				)}
				{checkAvailabilityModal && (
					<CheckAvailabilityModal
						modal={checkAvailabilityModal}
						setModal={() =>
							props.history.push(
								`/compound-details/${propertyDetails.coumound?.id}`
							)
						}
					/>
				)}
				{callModal && (
					<CallModal
						modal={callModal}
						setModal={setCallModal}
						phone={propertyDetails?.sales_rep?.phone}
					/>
				)}
				{messageModal && (
					<MessageModal
						modal={messageModal}
						setModal={setMessageModal}
						item={propertyDetails}
						type="unit"
					/>
				)}
			</div>
		</div>
	);
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number.toFixed(1));
};

export default PropertyBuyDetails;
